import React, { useState } from 'react';
import { Button, Modal, ModalHeader, ModalBody } from 'reactstrap';

const RecommendedInventoryIndicationModal = (props) => {
    return (
        <div>
            <Modal isOpen={props.isOpen}
                className='modal-dialog-centered modal-dialog--primary m-auto logout_modal_width align_indication_modal'
            >
                <ModalBody className='deleteModalBody'>
                    <div style={{ marginBottom: 20, fontSize: 16 }}>To customize your options, navigate to recommended inventories and create your checklist.</div>
                    <Button color="primary" outline
                        onClick={props.closeModal}
                        className='deleteModalBtn marginRight'>Close</Button>
                </ModalBody>
            </Modal>
        </div>
    );
}

export default RecommendedInventoryIndicationModal;
